import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import NavBar from "components/shared/NavBar";
import Footer from "components/landing/Footer";
import oLogo from 'assets/images/png/logo.png';

export default function Policy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return <>
    <NavBar />
    <main className="pt-24 pb-16 px-6 md:px-20 max-w-4xl mx-auto text-gray-700 dark:text-gray-300">

      <section className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-8">
        <img src={oLogo} alt="BrewControl logo" className="w-16 p-2 bg-primary-500 dark:bg-primary-dark rounded-full" />
        <div>
          <h1 className="text-3xl font-bold text-gray-800 dark:text-gray-100">Política de Privacidad</h1>
          <p className="text-sm text-gray-500 mt-1">Última actualización: mayo de 2026</p>
        </div>
      </section>

      <p className="mb-6 leading-relaxed">
        En <strong>BrewControl</strong> respetamos la privacidad de nuestros usuarios. Esta Política de Privacidad
        explica cómo recopilamos, usamos, divulgamos y protegemos tu información cuando utilizás nuestra plataforma,
        disponible como aplicación móvil y panel administrativo web. Por favor leé esta política con atención.
        Al registrarte y usar el servicio, aceptás las condiciones aquí descritas.
      </p>
      <p className="mb-6 leading-relaxed">
        Nos reservamos el derecho de modificar esta Política en cualquier momento. Los cambios serán notificados
        actualizando la fecha de "Última actualización" y, cuando corresponda, mediante aviso por correo electrónico.
        El uso continuado del servicio tras la publicación de los cambios implica la aceptación de la nueva versión.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">1. Información que recopilamos</h2>
      <p className="mb-4 leading-relaxed">
        Podemos recopilar información sobre vos de las siguientes maneras:
      </p>

      <h3 className="font-semibold text-base mt-4 mb-2 text-gray-800 dark:text-gray-100">Datos personales</h3>
      <p className="mb-4 leading-relaxed">
        Información de identificación personal —como nombre, correo electrónico y contraseña— que proporcionás
        voluntariamente al registrarte. Esta información está disponible únicamente para el equipo de BrewControl
        y no se comparte con terceros sin tu consentimiento.
      </p>

      <h3 className="font-semibold text-base mt-4 mb-2 text-gray-800 dark:text-gray-100">Datos de uso</h3>
      <p className="mb-4 leading-relaxed">
        Información que nuestros servidores recopilan automáticamente cuando accedés a la plataforma, como
        acciones realizadas dentro de la aplicación e interacciones registradas en archivos de log.
      </p>

      <h3 className="font-semibold text-base mt-4 mb-2 text-gray-800 dark:text-gray-100">Datos financieros</h3>
      <p className="mb-4 leading-relaxed">
        No almacenamos datos de tarjetas de crédito ni información bancaria. Los pagos son procesados por
        pasarelas de pago seguras (dLocal Go, MercadoPago). Te recomendamos revisar las políticas de privacidad
        de dichos proveedores directamente.
      </p>

      <h3 className="font-semibold text-base mt-4 mb-2 text-gray-800 dark:text-gray-100">Acceso al dispositivo móvil</h3>
      <p className="mb-4 leading-relaxed">
        La aplicación móvil puede solicitar acceso a la cámara de tu dispositivo para funcionalidades como el
        escaneo de códigos QR. Podés modificar estos permisos en cualquier momento desde la configuración de tu
        dispositivo.
      </p>

      <h3 className="font-semibold text-base mt-4 mb-2 text-gray-800 dark:text-gray-100">Notificaciones push</h3>
      <p className="mb-4 leading-relaxed">
        Podemos enviarte notificaciones push relacionadas con tu cuenta o el funcionamiento de la aplicación.
        Podés desactivarlas en cualquier momento desde la configuración de tu dispositivo.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">2. Uso de tu información</h2>
      <p className="mb-4 leading-relaxed">
        Usamos la información recopilada para:
      </p>
      <ul className="list-disc ml-6 mb-4 space-y-2">
        <li>Crear y administrar tu cuenta.</li>
        <li>Procesar pagos y gestionar tu suscripción.</li>
        <li>Enviarte comunicaciones relacionadas con tu cuenta o el servicio.</li>
        <li>Analizar el uso de la plataforma para mejorar la experiencia.</li>
        <li>Prevenir fraudes y proteger la seguridad del sistema.</li>
        <li>Cumplir con obligaciones legales aplicables.</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">3. Divulgación de tu información</h2>
      <p className="mb-4 leading-relaxed">
        No vendemos ni alquilamos tu información personal a terceros. Podemos compartirla únicamente en los
        siguientes casos:
      </p>
      <ul className="list-disc ml-6 mb-4 space-y-2">
        <li><strong>Por requerimiento legal:</strong> cuando sea necesario para responder a procesos legales o proteger derechos de terceros.</li>
        <li><strong>Proveedores de servicios:</strong> con terceros que prestan servicios en nuestro nombre (procesamiento de pagos, hosting, análisis), bajo acuerdos de confidencialidad.</li>
        <li><strong>Con tu consentimiento:</strong> en cualquier otro caso, previamente con tu autorización expresa.</li>
      </ul>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">4. Sitios de terceros</h2>
      <p className="mb-4 leading-relaxed">
        La plataforma puede contener enlaces a sitios web de terceros. Esta Política de Privacidad no aplica
        a dichos sitios. Te recomendamos revisar sus políticas de privacidad antes de proporcionar cualquier
        información personal.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">5. Seguridad de tu información</h2>
      <p className="mb-4 leading-relaxed">
        Implementamos medidas técnicas y organizativas razonables para proteger tu información personal.
        Sin embargo, ningún sistema de transmisión o almacenamiento de datos es completamente seguro.
        Si bien hacemos todo lo posible para proteger tus datos, no podemos garantizar seguridad absoluta.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">6. Menores de edad</h2>
      <p className="mb-4 leading-relaxed">
        BrewControl no está dirigida a menores de 18 años. No recopilamos intencionalmente información de
        menores. Si tomás conocimiento de que un menor ha proporcionado datos personales, contactanos para
        que podamos eliminar dicha información.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">7. Tus derechos</h2>
      <p className="mb-4 leading-relaxed">
        De acuerdo con la Ley N° 18.331 de Protección de Datos Personales de Uruguay, tenés derecho a:
      </p>
      <ul className="list-disc ml-6 mb-4 space-y-2">
        <li>Acceder a los datos personales que tenemos sobre vos.</li>
        <li>Rectificar datos incorrectos o incompletos.</li>
        <li>Solicitar la eliminación de tus datos, salvo que exista obligación legal de conservarlos.</li>
        <li>Oponerte al tratamiento de tus datos para determinados fines.</li>
      </ul>
      <p className="mb-4 leading-relaxed">
        Para ejercer estos derechos, podés contactarnos en la dirección indicada al final de este documento.
        También podés actualizar tus datos desde el panel administrativo.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">8. Términos y Condiciones</h2>
      <p className="mb-4 leading-relaxed">
        Esta Política de Privacidad debe leerse en conjunto con nuestros{" "}
        <Link to="/terminos" className="underline text-primary-500">Términos y Condiciones</Link>.
      </p>

      <h2 className="text-xl font-bold mt-8 mb-3 text-gray-800 dark:text-gray-100">9. Contacto</h2>
      <p className="mb-4 leading-relaxed">
        Si tenés preguntas o consultas sobre esta Política de Privacidad, podés contactarnos en:
      </p>
      <address className="not-italic mb-8 leading-relaxed">
        <strong>BrewControl</strong><br />
        Puntas de Valdez, San José, Uruguay<br />
        <a href="mailto:admin@brewcontrol.uy" className="underline text-primary-500">admin@brewcontrol.uy</a><br />
        <span className="text-sm text-gray-500 mt-2 block">Administrado por Leandro Curbelo · C.I. 5.048.194-3</span>
      </address>

    </main>
    <Footer />
  </>;
}
